import { ReviewModel } from '@app/models/review.model';

export interface ReviewInfos {
    note: number;
    average: ReviewAverage[];
    reviewCount: number;
    reviews: ReviewModel[];
}

export interface ReviewAverage {
    label: string;
    note: number;
}

export enum REVIEWS_SORT {
    DATE_ASC,
    DATE_DESC,
    RATE_ASC,
    RATE_DESC,
    HELPFULL,
}

export interface RatingValues {
    note: number;
    count: number;
}
